import type { GetRiskInternalAuditResultByIdResponse } from '@risksmart-app/trpc/src/types';
import type { GetRiskInternalAuditResultByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRiskInternalAuditResultByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetRiskInternalAuditResultByIdArgs = {
  id: string;
};

/**
 * V2 looks a single Id up against BOTH risk result tables and returns two
 * typed arrays; the tRPC read returns them as one compound object.
 */
export const useGetRiskInternalAuditResultById = createQueryHook<
  UseGetRiskInternalAuditResultByIdArgs,
  GetRiskInternalAuditResultByIdResponse,
  GetRiskInternalAuditResultByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.internalAuditResult.riskInternalAuditResultById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({
    risk_controlled_internal_audit_result: data.controlled,
    risk_uncontrolled_internal_audit_result: data.uncontrolled,
  }),
  graphqlDocument: GetRiskInternalAuditResultByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
